/*
  <mm-reviews>: filters the review cards by star rating.
*/

class MmReviews extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-mm-reviews-filter]');
    if (!this.select) return;

    this.abortController = new AbortController();
    this.select.addEventListener('change', () => this.filter(), { signal: this.abortController.signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
  }

  filter() {
    const value = this.select.value;

    for (const card of this.querySelectorAll('[data-mm-review]')) {
      const filled = !card.classList.contains('mm-review--empty');
      const match = filled && (value === 'all' || card.dataset.rating === value);
      card.hidden = !match && (filled || value !== 'all');
    }
  }
}

if (!customElements.get('mm-reviews')) customElements.define('mm-reviews', MmReviews);
